<template>
  <div class="emd-panel__section">
    <emd-text
      size="section"
      class="emd-panel__block"
    >
      {{ $t('keys.api-version') }}
    </emd-text>
    <emd-text
      size="caption"
      class="eu-display_inline-block emd-panel__block eu-basis_4"
    >
      V5.0
    </emd-text>
  </div>
</template>

<script>
import { EmdText } from 'emerald-vue/src/components'

export default {
  name: 'VersionAPI',

  components: {
    EmdText
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "keys": {
        "api-version": "Versão da API"
      }
    },
    "en-US": {
      "keys": {
        "api-version": "API version"
      }
    }
  }
</i18n>
